import * as Sentry from '@sentry/react';
import { isProduction, sentryDsn } from './config';

if (isProduction) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^https:\/\/pvo\.playwall\.co(\/|$)/],
  });
}
